'use strict';

import './style.css';


export default function(opts) {
	return function($log, $http, $q, $resolve, toastr) {
		'ngInject';

		return {
			require: '^incident',
			link: postLink,
			scope: {
				$data: '<data',
				$context: '<context',
				$$permission: '<permission',
			},
		};

		function postLink(scope, element, attrs, $incident) {
			element.addClass('btn-rest');
			scope.$incident = $incident;
			if (!scope.$context) scope.$context = {};
			$incident.$ready.then(function() {
				if (scope.$$permission !== undefined && !scope.$$permission) {
					element.addClass('disabled');
					attrs.$set('disabled', true);
					return;
				}
				element.on('click', function() {
					this.blur();
					if (element.hasClass('busy')) return;
					if (scope.$context.confirmMessage && !confirm(scope.$context.confirmMessage)) {
						return;
					}
					// var message = 'This incident is not active, are you sure you want to make changes?';
					// if ($incident.completed != false && !confirm(message)) {
					// 	return;
					// }
					element.addClass('busy');
					// We use ui-router's $resolve service to handle the resolve option.
					// In particular, using this we make the scope available for
					// injection into the resolve functions as "$scope"
					if (!opts.resolve) opts.resolve = {};
					opts.resolve.$scope = () => scope;
					$q.all([
						$resolve.resolve(opts.resolve),
					]).then(function(promiseData) {
						scope.$resolve = promiseData[0];
						var data = opts.data || scope.$data;
						if (opts.transformData) opts.transformData(data, scope);
						var deferred = $http({
							url: opts.url || opts.getUrl($incident, scope.$context),
							method: opts.method,
							data: data,
						})
						deferred.then(function success(response) {
							if (opts.onSuccess) opts.onSuccess(response, $incident, scope.$context);
							const successMessage = opts.successMessage || scope.$context.successMessage;
							if (successMessage) toastr.success(successMessage);
						}, function error(response) {
							$log.debug(response);
							if (opts.onError) opts.onError(response, $incident, scope.$context);
							if (opts.errorMessage) toastr.error(opts.errorMessage);
						}).finally(function() {
							element.removeClass('busy');
						});
					});
				});
			});
		}
	};
}
